import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputDirective, PositionType } from '@com-delta-omnichannel/mach';
import { BookWidgetAem } from '../../../models/book-widget-aem.interfaces';
import { BookWidgetFields } from '../../../models/book-widget-fields.interfaces';
import { ErrorStateDirective } from '../directive';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';

@Component({
  selector: 'idp-meeting-event-code',
  templateUrl: './meeting-event-code.component.html',
  styleUrls: ['./meeting-event-code.component.scss'],
  standalone: true,
  imports: [
    InfoTooltipComponent,
    InputDirective,
    ErrorStateDirective,
    CommonModule
  ]
})
export class MeetingEventCodeComponent {
  @Input() bookWidgetAem: BookWidgetAem = {} as BookWidgetAem;
  @Input() bookWidgetFields: BookWidgetFields = {} as BookWidgetFields;
  @Input() toolTipPosition: PositionType = 'bottom-left';

  @Output() meetingEventCodeChange = new EventEmitter<Event>();
}
